define(['jquery',
        'core/urls',
        'core/utilities',
        'bootstrap-toggle',
        'bootstrap-confirmation2',
    ],
    function ($, urls, utilities) {

        return {
            init: function () {
                $('input[type="checkbox"]').bootstrapToggle();
                $('input[name="enable_2fa"]').on('change', function (e) {
                    setTimeout(function () {
                        $('#user-toggles').submit();
                    }, 200);
                });

                $('.enable-2fa_js').on('change', function (e) {
                    let checkbox = $(this);
                    let userId = checkbox.parents('tr').data('user-id');
                    let endpoint = '';
                    if (checkbox.is(':checked')) {
                        endpoint = urls['account:enable-2fa']();
                    } else {
                        endpoint = urls['account:disable-2fa']();
                    }
                    $.post(endpoint, {
                        'user_id': userId
                    });
                });

                // ---------------
                // USER MANAGEMENT
                // ---------------

                utilities.confirmationTooltip("reset-2fa", (data) => {
                    let userId = data.id;
                    let resetEndpoint = urls['account:reset-2fa']();
                    $.post(resetEndpoint, {
                        'user_id': userId
                    }).done(function () {
                        location.reload();
                    });
                })

                utilities.confirmationTooltip("delete-user", (data) => {
                    let userId = data.id;
                    let endpoint = urls['account:update-user'](userId);
                    $.ajax(endpoint, {
                        type: 'DELETE',
                        success: function () {
                            location.reload();
                        }
                    });
                })

                $('input[type="checkbox"]').bootstrapToggle();
                $('input[name="enable_sso"]').on('change', function (e) {
                    setTimeout(function () {
                        $('#user-toggles').submit();
                    }, 200);
                });

                $('.enable-sso_js').on('change', function (e) {
                    let checkbox = $(this);
                    let userId = checkbox.parents('tr').data('user-id');
                    let endpoint = '';
                    if (checkbox.is(':checked')) {
                        endpoint = urls['account:enable-sso']();
                    } else {
                        endpoint = urls['account:disable-sso']();
                    }
                    $.post(endpoint, {
                        'user_id': userId
                    });
                });
            }
        };
    }
);